import instance from "lib/axiosInterceptor";
import {
  GetDocumentWorkspacesServiceResponse,
  GetDocumentFolderServicePayload,
  GetDocumentFolderServiceResponse,
  GetDocumentFolderByIdServicePayload,
  GetDocumentFolderByIdServiceResponse,
  GetDocumentByIdServiceResponse,
  CreateDocumentFolderServicePayload,
  CreateDocumentFolderServiceResponse,
  RenameDocumentFolderServicePayload,
  UpdateDocumentServicePayload,
  UpdateDocumentServiceResponse,
  DeleteDocumentFolderServicePayload,
  getLibraryFolderServiceResponse,
  GetDocumentDownloadServiceResponse,
  DeleteDocumentServicePayload,
  DeleteDocumentServiceResponse,
  UploadDocumentServiceResponse,
  GetMediaAssetsPayload,
  GetMediaAssetsResponse,
} from "interfaces";

/**
 * GET REQUESTS
 */

export async function getLibraryFolderService(
  id: string,
): Promise<getLibraryFolderServiceResponse> {
  const response = await instance.get<getLibraryFolderServiceResponse>(
    `/Document/Folder?id=${id}`,
  );
  return response.data;
}

export async function getDocumentWorkspacesService(): Promise<
  GetDocumentWorkspacesServiceResponse[]
> {
  const response =
    await instance.get<GetDocumentWorkspacesServiceResponse[]>(
      `/Document/Workspaces`,
    );

  return response.data;
}

export async function getDocumentFolderService(
  payload: GetDocumentFolderServicePayload,
): Promise<GetDocumentFolderServiceResponse> {
  const response = await instance.get<GetDocumentFolderServiceResponse>(
    `/Document/Folder`,
    {
      params: { workspaceId: payload.workspaceId },
    },
  );
  return response.data;
}

export async function getDocumentFolderByIdService(
  payload: GetDocumentFolderByIdServicePayload,
): Promise<GetDocumentFolderByIdServiceResponse> {
  const response = await instance.get<GetDocumentFolderByIdServiceResponse>(
    `/Document/Folder`,
    {
      params: { id: payload.id },
    },
  );
  return response.data;
}

export async function getDocumentByIdService(
  documentId: string,
): Promise<GetDocumentByIdServiceResponse> {
  const response = await instance.get<GetDocumentByIdServiceResponse>(
    `/Document/${documentId}`,
  );
  return response.data;
}

export async function getDocumentDownloadService(
  documentId: string,
): Promise<GetDocumentDownloadServiceResponse> {
  const response = await instance.get(`/Document/Download/${documentId}`, {
    responseType: "blob",
  });

  return response.data;
}

/**
 * POST REQUESTS
 */

export async function createDocumentFolderService(
  payload: CreateDocumentFolderServicePayload,
): Promise<CreateDocumentFolderServiceResponse> {
  const formData = new FormData();
  formData.append("title", payload.title);
  formData.append("folderId", payload.folderId);
  formData.append("workspaceId", payload.workspaceId);
  formData.append("file", payload.file);

  const response = await instance.post<CreateDocumentFolderServiceResponse>(
    `/Document/Folder`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
}

export async function renameDocumentFolderService(
  payload: RenameDocumentFolderServicePayload,
): Promise<void> {
  await instance.post(`/Document/Folder/Rename/${payload.folderId}`, null, {
    params: { newTitle: payload.newTitle },
  });
}

export async function updateDocumentService(
  payload: UpdateDocumentServicePayload,
): Promise<UpdateDocumentServiceResponse> {
  const formData = new FormData();
  formData.append("Title", payload.Title);
  formData.append("DocumentId", payload.DocumentId);
  formData.append("FolderId", payload.FolderId);

  const response = await instance.post<UpdateDocumentServiceResponse>(
    `/Document/Update`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
}

export async function deleteDocumentService(
  payload: DeleteDocumentServicePayload,
): Promise<DeleteDocumentServiceResponse> {
  const response = await instance.post(
    `/Document/Delete/${payload.documentId}`,
    null,
    {
      params: { archive: payload.archive },
    },
  );
  return response.data;
}

export async function deleteDocumentFolderService(
  payload: DeleteDocumentFolderServicePayload,
): Promise<any> {
  const response = await instance.post(
    `/Document/Folder/Delete/${payload.folderId}`,
    null,
    {
      params: { archive: payload.archive },
    },
  );
  return response.data;
}

export async function uploadDocumentService(
  formData: FormData,
  config?: any,
): Promise<UploadDocumentServiceResponse> {
  const response = await instance.post(`/Document/Upload`, formData, config);
  return response.data;
}

export async function getMediaAssetsService(
  params_: GetMediaAssetsPayload,
): Promise<GetMediaAssetsResponse> {
  const params: GetMediaAssetsPayload = {
    ...params_,
  };

  // Remove undefined values
  Object.keys(params).forEach((key) => {
    if (params[key as keyof GetMediaAssetsPayload] === undefined) {
      delete params[key as keyof GetMediaAssetsPayload];
    }
  });

  const response = await instance.get<GetMediaAssetsResponse>(
    `/Document/MediaAssets`,
    { params },
  );
  return response.data;
}
